<compass-pois-table [poisTableList]="subcategoriesList" style="width: 100%;">
</compass-pois-table>